export class LicitoCpn {
    constructor({ tipoFrmEmpresa }) {
        this.tipoFrmEmpresa = tipoFrmEmpresa;

        this.model = {
            transaccion_realiza: {
                value: '',
                header: 'Describa la transacción u operación que realiza con la compañía:',
                required: 'Descripción es requerido',
                maxLength: 'Máximo 1000 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 1000,
                min: 4
            },
            valor_total_bien_servicio: {
                value: 0,
                header: 'Valor total del bien/servicio:',
                headerPorTipo: {
                    FRM_TOYOTA: 'Valor total del bien USD:',
                    FRM_DIFARE: 'Valor total del contrato USD:',
                },
                required: 'Valor requerido',
            },
            moneda: {
                value: null,
                header: 'Moneda:',
                required: 'Moneda es requerido',
            },
            pais_ol: {
                value: null,
                header: 'País:',
                headerPorTipo: {
                    FRM_TOYOTA: 'Pais de donde proviene el pago:',
                    FRM_DIFARE: 'Pais de donde proviene el pago:',
                },
                required: 'País es requerido'
            },
            provincia_ol: {
                value: null,
                header: 'Provincia:',
                headerPorTipo: {
                    FRM_TOYOTA: 'Provincia de donde proviene el pago:',
                    FRM_DIFARE: 'Provincia de donde proviene el pago:',
                },
                required: 'Provincia es requerido'
            },
            ciudad_ol: {
                value: null,
                header: 'Ciudad:',
                headerPorTipo: {
                    FRM_TOYOTA: 'Ciudad de donde proviene el pago:',
                    FRM_DIFARE: 'Ciudad de donde proviene el pago:',
                },
                required: 'Ciudad es requerida'
            },
            canton_ol: {
                value: '',
                header: 'Ciudad',
                headerPorTipo: {
                    FRM_TOYOTA: 'Ciudad de donde proviene el pago:',
                    FRM_DIFARE: 'Ciudad de donde proviene el pago:',
                },
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
                required: 'Ciudad es requerida'
            },
            fecha_transaccion: {
                value: new Date(),
                header: 'Fecha de la transacción u operación (día/mes/año):',
                required: 'Fecha de la transacción u operación es requerida',
            },
            motivo_compra: {
                value: '',
                header: 'Propósito de la relación comercial o contractual/Motivo de la compra del bien:',
                maxLength: 'Máximo 250 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 250,
                min: 4,
                required: 'Motivo de la compra es requerido',
            },
            ubicacion_bien: {
                value: '',
                header: 'Ubicación del bien:',
                maxLength: 'Máximo 250 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 250,
                min: 4,
                required: 'Ubicación del bien es requerida',
            },
        }
        Object.keys(this.model).forEach((key) => {
            const campo = this.model[key];
            if (campo.headerPorTipo && tipoFrmEmpresa && campo.headerPorTipo[tipoFrmEmpresa] !== undefined) {
                campo.header = campo.headerPorTipo[tipoFrmEmpresa];
            }
        });
    }
    optionLabel = 'nombre';
}